import ServicePage from '../servicePage/ServicePage';
import { webDevelopmentServiceData } from '../../data/webDevelopmentServiceData';

const WebDevelopmentPage = () => {
  return <ServicePage serviceData={webDevelopmentServiceData} />;
};

export default WebDevelopmentPage;